import DigitalHumansAPI from '../../api/digitalHumans';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
  },
};

const getters = {
  getDigitalHumans: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getDigitalHumanById: $state => id =>
    $state.records.find(e => e.id === Number(id)),
};

const mutations = {
  SET_DIGITAL_HUMANS($state, records) {
    $state.records = records;
  },
  ADD_DIGITAL_HUMAN($state, record) {
    $state.records.push(record);
  },
  UPDATE_DIGITAL_HUMAN($state, record) {
    const idx = $state.records.findIndex(e => e.id === record.id);
    if (idx !== -1) $state.records.splice(idx, 1, record);
  },
  DELETE_DIGITAL_HUMAN($state, id) {
    $state.records = $state.records.filter(e => e.id !== id);
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await DigitalHumansAPI.get();
      commit('SET_DIGITAL_HUMANS', data.payload || data);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, payload) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await DigitalHumansAPI.createWithInboxes(payload);
      commit('ADD_DIGITAL_HUMAN', data);
      return data;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...updateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await DigitalHumansAPI.updateWithInboxes(id, updateData);
      commit('UPDATE_DIGITAL_HUMAN', data);
      return data;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    try {
      await DigitalHumansAPI.delete(id);
      commit('DELETE_DIGITAL_HUMAN', id);
    } catch (error) {
      throw error;
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
